import { render, staticRenderFns } from "./OrganisationDetail.vue?vue&type=template&id=0807f31f&"
import script from "./OrganisationDetail.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDetail.vue?vue&type=style&index=0&id=0807f31f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports